export const UNAUTHENTICATED_ENTRY = '/login';
export const APP_PREFIX_PATH = 'JumpFive';
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/home`;
export const REDIRECT_URL_KEY = 'redirect';
export const AUTH_PREFIX_PATH = '/auth';